<template lang="pug">
  .component-client-list-form.filter-form
    .row
      .column
        label Client
        input-form(:fields="['query']", :placeholders="['Client search']", @updatedData="setSearch")
      .columns
        label Status
        select(v-model="search.status")
          option(:value="null", disabled, selected) Status
          option ACTIVE
          option SUSPENDED
          option CANCELED
          option ON HOLD
      .columns
        label Client type
        SelectizeClientType(@optionSelected="setClientType", @optionRemoved="search.client_type = null")
      .columns
        a.fa.fa-filter.fa-2x(@click="setFilters")
</template>

<script>
import InputForm from './InputForm'
import DatePicker from '../../DatePicker'
import SelectizeClientType from '../lists/selectize/SelectizeClientType'
import RangePicker from '../../RangePicker'
import SearchEntity from "../SearchEntity.vue";

export default {
  name: 'ClientListForm',
  components: {SearchEntity, RangePicker, SelectizeClientType, DatePicker, InputForm},
  data() {
    return {
      search: {
        client_type: null,
        query: null,
        status: null,
      }
    }
  },
  methods: {
    selectClient(id){
      this.$router.push({name: 'client', params: {id}})
    },
    setRange(range) {
      this.search.created_from = range.from
      this.search.created_to = range.to
    },
    setSearch(obj) {
      this.search = Object.assign({}, obj)
      this.$emit('setSearch', this.search)
    },
    setFilters() {
      this.search.query = null
      this.$emit('setSearch', this.search)
    },
    setClientType(obj) {
      this.search.client_type = obj.id
    }
  },
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientListForm.vue?33ba0d21